<template>
    <div class="nevs-content">
        <NevsCard style="clear: both;">
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key" :style="{ 'color' : item.color }">
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.id }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.email }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.oib }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.time }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.approved_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.processed_display }}</td>
                    <td>
                        <span :title="$LANG.Get('tooltips.openInNewWindow')" class="nevs-table-button"
                              @click="openClick(item.id, true)"><i class="fa-solid fa-up-right-from-square"></i></span>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";

export default {
    name: "ModuleRegistrations",
    components: {NevsTable, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'id',
                        width: '50px',
                        sortable: 'true',
                        label: this.$LANG.Get('fields.id')
                    },
                    {
                        name: 'name',
                        sortable: 'false',
                        label: this.$LANG.Get('fields.name')
                    },
                    {
                        name: 'email',
                        sortable: 'false',
                        label: this.$LANG.Get('fields.email')
                    },
                    {
                        name: 'oib',
                        sortable: 'false',
                        label: this.$LANG.Get('fields.oib')
                    },
                    {
                        name: 'time',
                        sortable: 'true',
                        label: this.$LANG.Get('fields.time')
                    },
                    {
                        name: 'approved',
                        width: '100px',
                        label: this.$LANG.Get('fields.approved')
                    },
                    {
                        name: 'processed',
                        width: '120px',
                        label: this.$LANG.Get('fields.processed')
                    },
                    {
                        name: 'actions',
                        width: '50px',
                        label: ''
                    }
                ],
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'processed',
                    descending: false
                },
                filterTimer: null,
                height: '0px'
            }
        }
    },
    methods: {
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/registrations/' + id);
                window.open(routeData.href);
            } else {
                this.$router.push('/registrations/' + id);
            }
        },
        reloadTable(request) {
            let vm = this;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'registrations', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.serverError'), type: 'alert'});
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 205 + 'px';
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'registrations');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.registrations'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.$CROSS_TAB_BUS.ListenToEvent('reload-registrations', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    }
}
</script>

<style scoped>

</style>